import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Creates a new object from the list of key-value pairs.
 * Inverse of Object.entries().
 *
 * @param {Array[]} entries Array of key-value pairs (arrays).
 * @returns {Object} New object with the keys associated with the values.
 *
 * @example
 * > fromEntries([['foo', 1], ['bar', 2]])
 * { foo: 1, bar: 2 }
 */
export function fromEntries(entries) {
  // eslint-disable-next-line no-use-before-define
  return (entries || []).reduce(insertEntry, {});
}
/**
 * Insert an key-value pair into an object.
 * Primarily used with Array.reduce().
 *
 * @param {Object} obj Target object for inserting the entry.
 * @param {Array} entry Key-value pair (array) to insert.
 * @returns {Object} Original object with the new entry inserted.
 *
 * @example
 * > [['foo', 1], ['bar', 2]].reduce(insertEntry, { alpha: 0 })
 * { alpha: 0, foo: 1, bar: 2 }
 */

export function insertEntry(object, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  object[key] = value;
  return object;
}
/**
 * Creates a new object from the passed object, including only the specified keys.
 * Ignores non-existent keys.
 *
 * @param {string[]} keys Keys to pick from the passed oject.
 * @param {Object} object Object to pick keys from.
 * @returns {Object} New object with the picked keys only.
 *
 * @example
 * > pick(['a', 'c'], { a: null, b: null })
 * { a: null }
 */

export function pick(keys, object) {
  if (!keys || !object) {
    return {};
  }

  return keys.reduce(function (memo, key) {
    return key in object ? (memo[key] = object[key], memo) : memo;
  }, {});
}
/**
 * Creates a new object from the passed object, omitting the specified keys.
 * Ignores non-existent keys.
 *
 * @param {string[]} keys Keys to omit from the passed oject.
 * @param {Object} object Object to omit keys from.
 * @returns {Object} New object without the omitted keys.
 *
 * @example
 * > omit(['a', 'c'], { a: null, b: null })
 * { b: null }
 *
 * > omit([], { a: null, b: null })
 * { a: null, b: null }
 */

export function omit(keys, object) {
  if (!object) {
    return {};
  }

  var copy = _objectSpread({}, object);

  (keys || []).forEach(function (key) {
    return delete copy[key];
  });
  return copy;
}
/**
 * Create a new object with the keys changed by the transform.
 *
 * @param {Function} transform Function mapping the old key to the new key.
 * @param {Object} object Object whose keys should change.
 * @returns {Object} New object with all the keys transformed.
 *
 * @example
 * > transformKeys(key => key.toUpperCase(), { a: 'foo', b: 'bar' })
 * { A: 'foo', B: 'bar' }
 */

export function transformKeys(transform, object) {
  return Object.entries(object).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return [transform(key), value];
  }).reduce(insertEntry, {});
}
/**
 * Create a new object with the values changed by the transform.
 *
 * @param {Function} transform Function mapping the old value to the new value.
 * @param {Object} object Object whose values should change.
 * @returns {Object} New object with all the values transformed.
 *
 * @example
 * > transformValues(value => value.toUpperCase(), { a: 'foo', b: 'bar' })
 * { a: 'FOO', b: 'BAR' }
 */

export function transformValues(transform, object) {
  return Object.entries(object).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return [key, transform(value)];
  }).reduce(insertEntry, {});
}